export type FormulaElement = PointerElement | SignElement | ObjectElement

interface Element {
    error?: boolean
    hidden?: boolean
    selected?: boolean
}

export interface PointerElement extends Element {
    type: 0
}

export interface SignElement extends Element {
    type: 1
    value: MathSign

}

export interface ObjectElement extends Element {
    type: 2
    value: string
}

export enum MathSign {
    MORE_OR_EQUAL = '>=',
    LESS_OR_EQUAL = '<=',
    NOT_EQUAL = '!=',
    PLUS = '+',
    MINUS = '-',
    MULTIPLY = '*',
    DIVIDE = '/',
    LEFT_PARENTHESIS = '(',
    RIGHT_PARENTHESIS = ')',
    GREATER_THEN = '>',
    LESS_THEN = '<',
    EQUAL = '=',
    POWER = '^',
    NOT = '!',
    IF_MULTIPLE = 'ЕСЛИМН',
    IF = 'ЕСЛИ',
    ARGUMENT_DIVIDER = ';'
}
